import { useState } from 'react';
import { Tabs } from 'antd';
import { PhoneOutlined, TeamOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import PageScaffold from '../../../components/PageScaffold';
import VoipCallsTab from './VoipCallsTab';
import VoipUsersTab from './VoipUsersTab';

export const VOIP_CALLS_PAGE_PATH = '/voip-calls';
export const VOIP_CALLS_PAGE_TITLE = 'VoIP';

const TAB_KEYS = {
  calls: 'appels',
  users: 'utilisateurs',
};

const VoipCallsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') ?? TAB_KEYS.calls);

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  return (
    <PageScaffold
      title={VOIP_CALLS_PAGE_TITLE}
      subtitle="Timeline et points de rupture des appels LiveKit"
      breadcrumbItems={[{ title: VOIP_CALLS_PAGE_TITLE }]}
    >
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={[
          {
            key: TAB_KEYS.calls,
            label: 'Appels',
            icon: <PhoneOutlined />,
            children: <VoipCallsTab />,
          },
          {
            key: TAB_KEYS.users,
            label: 'Utilisateurs',
            icon: <TeamOutlined />,
            children: <VoipUsersTab />,
          },
        ]}
      />
    </PageScaffold>
  );
};

export default VoipCallsPage;
